<nz-card class="activity-card shadow-sm border border-gray-200" [class.hide-dots]="!data?.marketingFormId">
  <!-- Header -->
  <div class="flex justify-between items-center mb-2">
    <div class="flex items-center gap-2">
      <div class="font-semibold text-base text-gray-800 flex items-center">
        <span class="border-l-4 border-blue-500 pl-2">市场活动申请</span>
      </div>
    </div>
    <!-- <div>
      申请金额 <span class="font-semibold ml-1" style="color: #007BC0;">CNY {{ formatMoney(data.requestedAmount) }}</span>
    </div> -->
  </div>

  <div class="h-px bg-gray-200 my-3" style="border-top: 1px dashed #ccc;"></div>
  <!-- 申请信息 -->
  <div class="rounded-md mb-3">
    <div class="info-list text-gray-700 text-sm">

      <!-- <div class="info-row">
        <span class="label">状态：</span>
        <span class="value" *ngIf="data.status !== '--'">
          <custom-tag [content]="data.status" [backgroundColor]="getColorByStatus(data.status,true,false)"
            [fontColor]="getColorByStatus(data.status,false,false)"
            [borderColor]="getColorByStatus(data.status,false,true)"></custom-tag>
        </span>
      </div> -->
      <div class="info-row">
        <span class="label">活动方案：</span>
        <span class="value">{{ data.eventPlanRelease }}</span>
      </div>
      <div class="info-row">
        <span class="label">产品线：</span>
        <span class="value">{{ data.productLine }}</span>
      </div>

      <div class="info-row">
        <span class="label">产品：</span>
        <span class="value" style="max-width: 300px; display: inline-flex;">
          <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; margin-right: 8px;">{{
            data.materialDesc }}</span>
          <a class="label" style="white-space: nowrap; color: #007BC0;" (click)="onViewClick()">查看 ></a>
        </span>
      </div>

      <div class="info-row">
        <span class="label">数量：</span>
        <span class="value">{{ data.totalQuantity }}</span>
      </div>

      <div class="info-row">
        <span class="label">申请编号：</span>
        <span class="value">{{ data.activityRequestNo }}</span>
      </div>

      <div class="info-row">
        <span class="label">电子签签署完成日期：</span>
        <span class="value">{{ formatDisplayDate(data.esignCompleteTime) }}</span>
      </div>

      <div class="info-row">
        <span class="label">活动举办日期：</span>
        <span class="value">{{ formatDisplayDate(data.eventDate) }}</span>
      </div>

    </div>
  </div>

</nz-card>

<div class="dual-connector" *ngIf="data?.marketingFormId"></div>
<!-- 分割线 -->
<nz-card class="activity-card shadow-sm border border-gray-200" *ngIf="data?.marketingFormId">
  <!-- 核销信息 -->
  <div class="rounded-md mb-3">
    <div class="flex justify-between items-center mb-2">
      <div class="font-semibold text-gray-800">核销信息</div>
      <!-- <div class="text-gray-700 text-sm">
        总核销金额
        <span class="font-semibold ml-1" style="color: #007BC0;">
          CNY {{ formatMoney(data?.verificationAmount) }}
        </span>
      </div> -->
    </div>

    <div class="h-px bg-gray-200 my-3" style="border-top: 1px dashed #ccc;"></div>
    <div class="rounded-md mb-3">
      <div class="flex justify-between text-gray-700 text-sm gap-8">

        <!-- 左列 -->
        <div class="flex-1 info-list">
          <div class="info-row">
            <span class="label">审批状态：</span>
            <!-- <span class="value" *ngIf="data?.approvalStatus">
              <custom-tag [content]="data?.approvalStatus"
                [backgroundColor]="getColorByApprovalStatus(data?.approvalStatus,true,false)"
                [fontColor]="getColorByApprovalStatus(data?.approvalStatus,false,false)"
                [borderColor]="getColorByApprovalStatus(data?.approvalStatus,false,true)"></custom-tag>
            </span> -->
            <span class="value" *ngIf="data.status !== '--'">
              <custom-tag [content]="data.status" [backgroundColor]="getColorByStatus(data.status,true,false)"
                [fontColor]="getColorByStatus(data.status,false,false)"
                [borderColor]="getColorByStatus(data.status,false,true)"></custom-tag>
            </span>
          </div>
          <div class="info-row">
            <span class="label">核销编号：</span>
            <span class="value">{{ data?.verificationCode }}</span>
          </div>

          <div class="info-row">
            <span class="label">核销通过日期：</span>
            <span class="value">{{ formatDisplayDate(data?.verificationDate) }}</span>
          </div>
          <div class="info-row">
            <span class="label">快递单号：</span>
            <span class="value">{{ data?.expressNumber }}</span>
          </div>

        </div>
      </div>
    </div>

  </div>

  <!-- 分割线 -->
  <div class="h-px bg-gray-200 my-3"></div>

  <!-- 按钮组 -->
  <div class="flex justify-end gap-2 mt-5">
    <button nz-button nzType="text" class="func-button flex justify-center" (click)="handleOpenModal()"
      [ngStyle]="{ visibility: isAttachmentExist() ? 'visible' : 'hidden' }">
      查看售出目标达成截屏
    </button>
  </div>
</nz-card>
<!-- spark-plug-list-modal.component.html -->
<nz-modal [(nzVisible)]="isTargetVisible" nzCentered [nzFooter]="null" (nzOnCancel)="handleCancelView()">
  <div class="target-container" *nzModalContent>
    <h3 class="target-title">
      <span class="border-l-4 pl-2" class="target-info">{{data?.productLine}}（{{ data?.totalQuantity }}）件</span>
    </h3>
    <div class="h-px bg-gray-200 my-3"></div>
    <div *ngFor="let item of data?.materialDtos" class="target-item">
      <div class="item-name">{{ item.productDesc }}（{{item.materialNo}}）</div>
      <div class="item-qty">
        <span class="label">数量</span>
        <span class="value">{{ item.quantity }}</span>
      </div>
      <div class="h-px bg-gray-200 my-3"></div>
    </div>
  </div>
</nz-modal>
<nz-modal [(nzVisible)]="isAttachmentVisible" [nzFooter]="null" [nzWidth]="'900px'" (nzOnCancel)="handleCancel()">
  <div class="attachment-container" *nzModalContent>
    <h3 class="invoice-title">
      <span class="border-l-4 pl-2" class="invoice-info">附件清单</span>
      <span class="sub">（核销编号{{ data?.verificationCode }}）</span>
    </h3>
    <div class="h-px bg-gray-200 my-3"></div>
    <div class="attachment-list">
      <div class="attachment-item">
        <div class="title">售出目标达成截屏</div>
        <div class="file-box">
          <a *ngFor="let item of data?.salesTargetScreenshot" href="{{item.filePath}}" target="_blank"
            class="file-link">
            {{item.fileName}}
          </a>
        </div>
      </div>
    </div>
  </div>
</nz-modal>